import { AnomalyPhase } from '@app/features/anomalies/anomaly.model';
import { UserRole } from '@app/features/users/user.model';

/**
 * Une annonce de nouveauté telle que la direction la tient à jour (RG-nouveaute-annonce). Elle n'a
 * pas de statut ; les dates sont à l'heure de Paris, sans décalage, comme celles d'une anomalie.
 */
export interface Announcement {
  id: string;
  title: string;
  /** Markdown brut, rendu sans HTML (RG-anomalie-markdown-sans-html). */
  content: string;
  targetRoles: UserRole[];
  /** Le parcours du catalogue que l'annonce propose : `<domaine>/<cas-d-usage>`. */
  tourId: string;
  /** `null` : affichée dès l'enregistrement. */
  startDate: string | null;
  startTime: string | null;
  /** `null` : affichée trente jours à partir de son début. */
  endDate: string | null;
  endTime: string | null;
  /** Début effectif de l'affichage, calculé par l'API. */
  displayedFrom: string;
  /** Fin effective de l'affichage (exclue), calculée par l'API. */
  displayedUntil: string;
  phase: AnomalyPhase;
  archived: boolean;
  createdBy: string;
  createdAt: string;
  updatedBy: string | null;
  updatedAt: string | null;
  archivedBy: string | null;
  archivedAt: string | null;
}

/**
 * Le bandeau d'une annonce qui concerne l'utilisateur maintenant, et qu'il n'a ni fermée ni suivie
 * jusqu'au bout. L'API les rend, les plus récentes en tête.
 */
export interface VisibleAnnouncement {
  id: string;
  title: string;
  content: string;
  tourId: string;
  displayedFrom: string;
  displayedUntil: string;
  updatedAt: string | null;
}

export interface AnnouncementRequest {
  title: string;
  content: string;
  targetRoles: UserRole[];
  tourId: string;
  /** `YYYY-MM-DD` */
  startDate: string | null;
  /** `HH:mm` */
  startTime: string | null;
  endDate: string | null;
  endTime: string | null;
}

/** Ce qu'un utilisateur a fait d'une annonce, que l'API retient (RG-nouveaute-memoire). */
export type AnnouncementOutcome = 'CLOSED' | 'TOUR_COMPLETED';

/** Durée d'affichage d'une annonce sans date de fin (décision 2026-032/07). */
export const ANNOUNCEMENT_DEFAULT_DAYS = 30;

/** Ce qu'un bandeau affiche : de quoi le dessiner, pour une annonce visible comme pour l'aperçu. */
export type BannerAnnouncement = Pick<VisibleAnnouncement, 'title' | 'content' | 'displayedFrom'>;
